export default {
	request( req, token ) {
		this.options.http._setHeaders.call( this, req, {
			"X-Requested-With": "XMLHttpRequest",
			Authorization: `Bearer ${token}`
		} );
	},
	response( res ) {
		if ( !res ) {
			return;
		}

		if ( res.status === 500 ) {
			const headers = this.options.http._getHeaders.call( this, res );
			const tokenHeader = headers.Authorization || headers.authorization;

			if ( tokenHeader ) {
				const token = tokenHeader.split( /Bearer:?\s?/i );

				return token[token.length > 1 ? 1 : 0].trim();
			}
		}

		return ( res.data || {} ).access_token;
	}
};
